import { render } from "./CountryOrBasinSelector.vue?vue&type=template&id=796ef1a2&scoped=true"
import script from "./CountryOrBasinSelector.vue?vue&type=script&lang=js"
export * from "./CountryOrBasinSelector.vue?vue&type=script&lang=js"

import "./CountryOrBasinSelector.vue?vue&type=style&index=0&id=796ef1a2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-796ef1a2"]])

export default __exports__